define(function (require, exports) {
    'use strict';

    exports.replace = function () {
        return function (input, search, replace) {
            var filteredString = '';

            if(input) {
                filteredString = input.replace(new RegExp(search, 'g'),
                    replace);
            }

            return filteredString;
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/filters/replace.js